import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../index.css";

const initialData = [
    {
        id: 1,
        studentName: "Rahul Kumar",
        admissionNo: "A101",
        regdNo: "R5001",
        session: "2024-25",
        classSection: "10-A",
        status: "Active",
    },
];

export default function Students() {
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [selected, setSelected] = useState(null);
    const [search, setSearch] = useState("");

    // Load data
    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem("students")) || [];

        if (saved.length === 0) {
            localStorage.setItem("students", JSON.stringify(initialData));
            setList(initialData);
        } else {
            setList(saved);
        }
    }, []);

    // Refresh
    useEffect(() => {
        const handleStorage = () => {
            const saved = JSON.parse(localStorage.getItem("students")) || [];
            setList(saved);
        };

        window.addEventListener("storage", handleStorage);

        return () => window.removeEventListener("storage", handleStorage);
    }, []);

    // Filter
    const filtered = list.filter((item) =>
        (item.studentName || "").toLowerCase().includes(search.toLowerCase())
    );

    // Delete
    const handleDelete = () => {
        if (!selected) return alert("Select row first");

        const updated = list.filter((l) => l.id !== selected.id);
        setList(updated);
        localStorage.setItem("students", JSON.stringify(updated));
        setSelected(null);
    };

    return (
        <>
            <style>{`
        .page { background:#f5f7fb; padding:20px; }
        .card { background:#fff; padding:15px; border-radius:8px; }

        .header {
          display:flex;
          justify-content:space-between;
          margin-bottom:10px;
        }

        .controls {
          display:flex;
          gap:10px;
          margin-bottom:10px;
          flex-wrap:wrap;
        }

        .search-box {
          padding:8px;
          border:1px solid #ccc;
          border-radius:4px;
        }

        .btn {
          padding:7px 12px;
          border:none;
          border-radius:4px;
          cursor:pointer;
        }

        .btn-dark { background:#2c3e50; color:#fff; }
        .btn-blue { background:#3498db; color:#fff; }
        .btn-red { background:#e74c3c; color:#fff; }

        table {
          width:100%;
          border-collapse:collapse;
        }

        th, td {
          padding:10px;
          border-bottom:1px solid #eee;
        }

        tr:hover { background:#f4f6f9; cursor:pointer; }
        .active-row { background:#eef3ff; }
      `}</style>

            <div className="page">
                <div className="card">

                    <div className="header">
                        <h3>Students</h3>
                        <div>{list.length} Records</div>
                    </div>

                    <div className="controls">

                        <input
                            className="search-box"
                            placeholder="Search Student Name"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />

                        <button
                            className="btn btn-dark"
                            onClick={() => navigate("/admin/students/add")}
                        >
                            + Add
                        </button>

                        <button
                            className="btn btn-blue"
                            onClick={() => {
                                if (!selected) return alert("Select row first");
                                navigate(`/admin/students/edit/${selected.id}`);
                            }}
                        >
                            Update
                        </button>

                        <button
                            className="btn btn-red"
                            onClick={handleDelete}
                        >
                            Delete
                        </button>
                        <button
                            className="btn btn-blue"
                            onClick={() => {
                                if (!selected) return alert("Select row first");
                                navigate(`/admin/students/view/${selected.id}`);
                            }}
                        >
                            View
                        </button>

                    </div>

                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                <th>S.ID</th>
                                <th>Student Name</th>
                                <th>Admission No</th>
                                <th>Regd.No</th>
                                <th>Session Name</th>
                                <th>Class-Section</th>
                                <th>Status</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filtered.map((item, index) => (
                                <tr
                                    key={item.id}
                                    className={selected?.id === item.id ? "active-row" : ""}
                                    onClick={() =>
                                        setSelected(selected?.id === item.id ? null : item)
                                    }
                                >
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selected?.id === item.id}
                                            onChange={() =>
                                                setSelected(selected?.id === item.id ? null : item)
                                            }
                                            onClick={(e) => e.stopPropagation()}
                                        />
                                    </td>

                                    <td>{index + 1}</td>
                                    <td>{item.studentName}</td>
                                    <td>{item.admissionNo}</td>
                                    <td>{item.regdNo}</td>
                                    <td>{item.session}</td>
                                    <td>{item.classSection}</td>
                                    <td>{item.status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                </div>
            </div>
        </>
    );
}